<template>
  <label class="checkbox-label" :class="isMobile() ? 'mobile-label' : ''">
    {{ label }}
    <input
      type="checkbox"
      v-on:click.stop="onClick()"
      :checked="value"
      :disabled="disabled"
    />
    <span
      :class="IsRadio ? 'radio-checkmark' : 'checkbox-checkmark'"
      :style="getStyle()"
    ></span>
  </label>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Checkbox",
  props: {
    label: {
      type: String,
      default: "label",
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    IsRadio: {
      type: Boolean,
      default: false,
    },
  },
  mounted: function() {
    this.$el.indeterminate = true;
  },
  computed: {
    ...mapGetters(["desktopStyles", "mobileStyles"]),
  },
  methods: {
    onClick() {
      switch (this.value) {
        case null:
        case false:
          this.$emit("change", true);
          this.$emit("input", true);
          this.$emit("click", true);
          break;
        case true:
          this.$emit("change", this.IsRadio ? true : false);
          this.$emit("input", this.IsRadio ? true : false);
          this.$emit("click", this.IsRadio ? true : false);
          break;
      }
    },
    lableOnClick() {
      this.$emit("click", this.value);
    },
    getStyle() {
      var style = [];
      if (this.value) {
        style.push(
          this.isMobile()
            ? this.mobileStyles.CommonColorBackground
            : this.desktopStyles.CommonColorBackground
        );
      } else {
        style.push(
          this.isMobile()
            ? this.mobileStyles.pendingStatusBackground
            : this.desktopStyles.pendingStatusBackground
        );
      }
      return style;
    },
  },
};
</script>
